module.exports = __webpack_public_path__ + "img/W-G37.1a09ca13.jpg";